import React from 'react';
import Loader from "../../../Loader";
import UtilsFunctions from "../../../../utils/UtilsFunctions";

const BalanceSheetTable = ({isLoad, initialData}) => {

  try {
    return (
      <div className={"BalanceSheetTable"}>

        <ul className={"BalanceSheetTableHeader"}>
          <li style={{width: "15%"}}>کد حساب</li>
          <li style={{width: "25%"}}>عنوان حساب</li>
          <li style={{width: "15%"}}>گردش بدهکار</li>
          <li style={{width: "15%"}}>گردش بستانکار</li>
          <li style={{width: "15%"}}>مانده بدهکار</li>
          <li style={{width: "15%"}}>مانده بستانکار</li>
        </ul>

        {isLoad ?
          <>
            {initialData?.data?.length > 0 &&
              <>
                {initialData?.data?.map((item, index) =>
                  <ul key={index + "body"}>
                    <li style={{width: "15%"}}>{item?.accountCode}</li>
                    <li style={{width: "25%"}}>{item?.accountName}</li>
                    <li style={{width: "15%"}}>{UtilsFunctions.addCommas(item?.bed)}</li>
                    <li style={{width: "15%"}}>{UtilsFunctions.addCommas(item?.bes)}</li>
                    <li style={{width: "15%"}}>{UtilsFunctions.addCommas(item?.bedRemaining)}</li>
                    <li style={{width: "15%"}}>{UtilsFunctions.addCommas(item?.besRemaining)}</li>
                  </ul>
                )}
                <ul className={"BalanceSheetTableFooter"}>
                  <li style={{width: "15%"}}>جمع کل</li>
                  <li style={{width: "25%"}}>.</li>
                  <li style={{width: "15%"}}>
                    {UtilsFunctions.addCommas(initialData?.data?.reduce((sum, item) => sum + +item.bed, 0))}
                  </li>
                  <li style={{width: "15%"}}>
                    {UtilsFunctions.addCommas(initialData?.data?.reduce((sum, item) => sum + +item.bes, 0))}
                  </li>
                  <li style={{width: "15%"}}>
                    {UtilsFunctions.addCommas(initialData?.data?.reduce((sum, item) => sum + +item.bedRemaining, 0))}
                  </li>
                  <li style={{width: "15%"}}>
                    {UtilsFunctions.addCommas(initialData?.data?.reduce((sum, item) => sum + +item.besRemaining, 0))}
                  </li>
                </ul>
              </>
            }
          </> : <Loader/>
        }

      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default BalanceSheetTable;